import React, { useState } from 'react'
import Headers from './Headers'
import { Box ,styled } from '@mui/material'
import Search from './Search'
import Conversation from './Conversation'

function Menu() {

    const[search,setSearch]=useState('')
    

    return (
        <Box>
           <Headers/>
           <Search setSearch={setSearch}/>
           <Conversation search={search} />
        </Box>
    )
}

export default Menu
